import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]
  static values = {
    defaultText: { type: String, default: "コピー" },
    successText: { type: String, default: "コピーしました" },
    errorText: { type: String, default: "手動で選択してください" }
  }

  connect() {
    this.labelInitiallyHidden = this.hasLabelTarget && this.labelTarget.classList.contains("hidden")
  }

  disconnect() {
    window.clearTimeout(this.resetTimer)
  }

  async copy(event) {
    event.preventDefault()

    if (!this.hasSourceTarget) return

    const text = this.sourceTarget.value || this.sourceTarget.textContent

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.copyWithSelection(text)
      }

      this.updateLabel(this.successTextValue)
    } catch (_error) {
      this.sourceTarget.select?.()
      this.updateLabel(this.errorTextValue)
    }
  }

  copyWithSelection(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-1000px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    textarea.remove()
  }

  updateLabel(text) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = text
      this.labelTarget.classList.remove("hidden")
    }

    window.clearTimeout(this.resetTimer)
    this.resetTimer = window.setTimeout(() => {
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = this.defaultTextValue
        if (this.labelInitiallyHidden) this.labelTarget.classList.add("hidden")
      }
    }, 1800)
  }
}
